import { useCallback, useRef } from 'react';

export const useScrollToNextTarget = () => {
  const targetElementsRef = useRef<NodeListOf<HTMLElement> | null>(null);
  const stickyElementRef = useRef<HTMLElement | null>(null);
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  const scrollToNextTarget = useCallback(() => {
    if (
      !targetElementsRef.current ||
      !stickyElementRef.current ||
      !scrollContainerRef.current
    ) {
      return;
    }

    const stickyOffset = stickyElementRef.current.offsetHeight; // height of sticky element
    const containerScrollTop = scrollContainerRef.current.scrollTop; // scroll position of container
    const stickyElementPositionOffset =
      stickyElementRef.current.getBoundingClientRect().top; // position of sticky element

    let nextTarget: null | HTMLElement = null;
    let minDistance = Number.MAX_SAFE_INTEGER;

    targetElementsRef.current.forEach((target) => {
      const targetElement = target;
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        containerScrollTop -
        stickyElementPositionOffset;

      if (targetPosition >= containerScrollTop + stickyOffset * 2) {
        const distance = targetPosition - (containerScrollTop + stickyOffset);

        if (distance < minDistance) {
          minDistance = distance;
          nextTarget = targetElement;
        }
      }
    });

    nextTarget = nextTarget || targetElementsRef.current[0];

    if (nextTarget) {
      const offsetPosition =
        nextTarget.getBoundingClientRect().top +
        containerScrollTop -
        stickyElementPositionOffset;

      scrollContainerRef.current.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }, []);

  return {
    targetElementsRef,
    stickyElementRef,
    scrollToNextTarget,
    scrollContainerRef,
  };
};
